module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab4",
      "name": "hres31x-tab4"
    }
  }, [(_vm.detail.tableIncome.total > 0) ? [_c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-btc icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['310']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row income-table-box"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 blank-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-2 blank-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 col-sm-4 currency"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC4']['20']) + " : " + _vm._s(_vm.detail.detail.desc_codecurr))])]), _vm._v(" "), _c('div', {
    staticClass: "row income-table-box"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-5 income-table-heading bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3 income-table-heading-center bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 income-table-heading-right bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC4']['50']))])]), _vm._v(" "), _vm._l((_vm.detail.tableIncome.rows), function(value, index) {
    return [_c('div', {
      staticClass: "row income-table-box",
      class: {
        'even': !_vm.pcDisp && index % 2 == 0
      }
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-5 income-table-body-left"
    }, [_vm._v(_vm._s(value.code) + " - " + _vm._s(value.desc_income))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 col-sm-3 income-table-body-center"
    }, [_vm._v(_vm._s(value.unit))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 col-sm-4 income-table-body-right"
    }, [_vm._v(_vm._s(value.qtyincome))])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "row income-table-box"
  }, [_c('div', {
    staticClass: "col-xs-12 blank"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pcDisp),
      expression: "!pcDisp"
    }],
    staticClass: "col-xs-12 bg-color-skin income-table-sum-header"
  }, [_vm._v(_vm._s(_vm.constLabels[_vm.nowLang].summary))])]), _vm._v(" "), _c('div', {
    staticClass: "row income-table-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pcDisp),
      expression: "pcDisp"
    }],
    staticClass: "col-sm-5 income-table-sum-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3 income-table-sum-center",
    class: {
      'bg-color-skin': _vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC4']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 income-table-sum-right",
    class: {
      'bg-color-skin': _vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.detail.detail.hour_income))])]), _vm._v(" "), _c('div', {
    staticClass: "row income-table-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pcDisp),
      expression: "pcDisp"
    }],
    staticClass: "col-sm-5 income-table-sum-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3 income-table-sum-center",
    class: {
      'bg-color-skin': _vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC4']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 income-table-sum-right",
    class: {
      'bg-color-skin': _vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.detail.detail.day_income))])]), _vm._v(" "), _c('div', {
    staticClass: "row income-table-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pcDisp),
      expression: "pcDisp"
    }],
    staticClass: "col-sm-5 income-table-sum-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3 income-table-sum-center",
    class: {
      'bg-color-skin': _vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC4']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 income-table-sum-right",
    class: {
      'bg-color-skin': _vm.pcDisp
    }
  }, [_vm._v(_vm._s(_vm.detail.detail.month_income))])])], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71ece77a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab4.vue
// module id = 3861
// module chunks = 1